<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingUserList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table
                :items-per-page="50"
                :footer-props="footerProps"
                :search="searchUserString"
                class="product-table"
                dense
                :headers="tableHeaders"
                :items="users"
        >
            <template v-slot:item="{ item }">
                <tr
                        :key="'user_' + item.id"
                        @click="handleTableRowClick(item)"
                        :class="{ activeTableRow: activeUser && parseInt(item.id) === parseInt(activeUser.id) }"
                >
                    <td>{{ item.name }}</td>
                    <td>{{ item.position }}</td>
                    <td style="text-align: end">{{ item.phone }}</td>
                    <td style="text-align: center">{{ item.email }}</td>
                    <td style="text-align: center">{{ item.role }}</td>
                    <td style="text-align: center">
                        <i
                                :class="{
                                      'fas fa-user-check': item.status === 'active',
                                      'fas fa-user-minus': item.status === 'inactive',
                                      'fas fa-user-lock': item.status === 'blocked'
                                    }"
                                :style="{
                                      color: item.status === 'active' ? 'green' :
                                             item.status === 'inactive' ? 'orange' :
                                             '#f41823',
                                      fontSize: '15px'
                                    }"
                        ></i>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import Store from "../../store";
import { mapGetters, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "user-list.vue",
    data() {
        return {
            footerProps: { "items-per-page-options": [25, 50, 100] },
            tableHeaders: [
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Position"),
                    align: "left",
                    value: "position"
                },
                {
                    text: this.t("Phone"),
                    align: "right",
                    value: "phone"
                },
                {
                    text: this.t("E-mail"),
                    align: "center",
                    value: "email"
                },
                {
                    text: this.t("Role"),
                    align: "center",
                    value: "role"
                },
                {
                    text: this.t("Status"),
                    align: "center",
                    value: "status"
                }
            ]
        };
    },
    mounted() {
        Store.dispatch("UserStore/getUserList");
    },
    computed: {
        ...mapState("UserStore", ["users", "loadingUserList", "activeUser", "searchUserString"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        handleTableRowClick(user) {
            if (!this.hasPermissionForAction(PermissionsConstants.USER, PermissionsConstants.VIEW)) {
                return;
            }
            if (this.$route.name !== "user-view") {
                this.$router.push({ name: "user-view", params: { userId: user.id } });

                return;
            }
            if (this.$route.name === "user-view" && parseInt(user.id) !== parseInt(this.$route.params.userId)) {
                this.$router.push({ name: "user-view", params: { userId: user.id } });
                Store.dispatch("UserStore/getUserData", user.id);
            }
        }
    }
};
</script>

<style scoped>
.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.dot {
    margin-top: 4px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}

.v-data-table-header {
    background-color: #f0f0f0;
}

::v-deep .v-data-table-header th {
    white-space: nowrap;
}

td {
    height: 25px !important;
}
</style>
